// Read-only link returned by the inspector backend (per-row payload).
export type ReferenceLink = {
  link_type: string
  name: string
  url: string
  description?: string | null
}

// Editable link used by admin CRUD payloads. Includes market scope and
// position so the admin form can build the inline-table editor.
export type ReferenceLinkInput = {
  link_type: string
  market: 'ANZ' | 'USA' | null
  name: string
  url: string
  description?: string | null
  display_order: number
}

export const MARKETS = ['ANZ', 'USA'] as const
export type Market = (typeof MARKETS)[number]
